import { useEffect, useState, useRef, useCallback } from 'react';
import { testimonialsApi } from '../../api/testimonialsApi';
import testimonialIcon from '../../assets/testimonials_icon.svg';
import './TestimonialsCarousel.css';

const CarouselRow = ({ testimonials, direction }) => {
  const trackRef = useRef(null);
  const singleSetWidth = useRef(0);
  const animRef = useRef(null);
  const scrollAccum = useRef(0);

  const items = [...testimonials, ...testimonials, ...testimonials];

  const handleLoop = useCallback(() => {
    const track = trackRef.current;
    if (!track || !singleSetWidth.current) return;
    if (track.scrollLeft >= singleSetWidth.current * 2) {
      track.scrollLeft -= singleSetWidth.current;
    } else if (track.scrollLeft <= 0) {
      track.scrollLeft += singleSetWidth.current;
    }
  }, []);

  useEffect(() => {
    const track = trackRef.current;
    if (!track || !testimonials.length) return;
    const cardEl = track.querySelector('.testimonials-carousel__card');
    if (!cardEl) return;
    singleSetWidth.current = (cardEl.offsetWidth + 24) * testimonials.length;
    track.scrollLeft = singleSetWidth.current;

    const tick = () => {
      scrollAccum.current += 0.25;
      if (scrollAccum.current >= 1) {
        const px = Math.floor(scrollAccum.current);
        track.scrollLeft += direction === 'left' ? px : -px;
        scrollAccum.current -= px;
        handleLoop();
      }
      animRef.current = requestAnimationFrame(tick);
    };
    animRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(animRef.current);
  }, [testimonials, direction, handleLoop]);

  return (
    <div className="testimonials-carousel__track" ref={trackRef}>
      {items.map((t, i) => (
        <div className="testimonials-carousel__card" key={`${t.id}-${i}`}>
          <div className="testimonials-carousel__grain" />
          <img src={testimonialIcon} alt="" className="testimonials-carousel__icon" />
          <p className="testimonials-carousel__text">{t.review}</p>
          <div className="testimonials-carousel__attribution">
            <span className="testimonials-carousel__author">{t.reviewAuthor}</span>
            {t.reviewLink && t.reviewLinkText && (
              <a href={t.reviewLink} target="_blank" rel="noopener noreferrer" className="testimonials-carousel__company">{t.reviewLinkText}</a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

const TestimonialsCarousel = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    testimonialsApi.getTestimonials()
      .then(data => setTestimonials(data?.length ? data : []))
      .catch(() => {});
  }, []);

  if (!testimonials.length) return null;

  const mid = Math.ceil(testimonials.length / 2);
  const topRow = testimonials.slice(0, mid);
  const bottomRow = testimonials.slice(mid);

  return (
    <section className="testimonials-carousel" id="section-testimonials">
      <h2 className="testimonials-carousel__title">What our partners say</h2>
      <div className="testimonials-carousel__rows">
        <CarouselRow testimonials={topRow} direction="left" />
        {bottomRow.length > 0 && <CarouselRow testimonials={bottomRow} direction="right" />}
      </div>
    </section>
  );
};

export default TestimonialsCarousel;
